import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import {
  Margin,
  MediaContextProvider,
  Theme,
  TypographyStyle,
} from '../components';
import {
  BenefitsAndPerks,
  CoreValues,
  CoreValuesMission,
  Footer,
  FrequentlyAskedQuestions,
  HeaderModule,
  LifeAtGlossier,
  MeetTheTeam,
  Navigation,
  OpenRoles,
} from '../modules';

export default function Home() {
  const openRolesRef = useRef();
  const coreValuesRef = useRef();
  const coreValuesMissionRef = useRef();
  const lifeAtGlossierRef = useRef();
  const benefitsAndPerksRef = useRef();
  const frequentlyAskedQuestionsRef = useRef();

  useEffect(() => {
    require('../analytics');
  }, []);

  return (
    <MediaContextProvider>
      <Theme>
        <Helmet>
          <html lang="en" />
          <meta
            charSet="utf-8"
            content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, user-scalable=no"
          />
          <meta
            name="description"
            content="Join our team. Glossier is giving voice through beauty as a direct-to-consumer company that leverages the power of personal narrative to own the beauty conversation on the internet."
          />
          <title>Life.Glossier - Careers at Glossier</title>
        </Helmet>
        <TypographyStyle />
        <Margin size={[0, 0, 8, 0]}>
          <Navigation
            references={{
              openRolesRef,
              coreValuesRef,
              coreValuesMissionRef,
              lifeAtGlossierRef,
              benefitsAndPerksRef,
              frequentlyAskedQuestionsRef,
            }}
          />
        </Margin>
        <HeaderModule reference={openRolesRef} />
        <CoreValuesMission ref={coreValuesMissionRef} />
        <CoreValues ref={coreValuesRef} />
        <LifeAtGlossier ref={lifeAtGlossierRef} />
        <BenefitsAndPerks ref={benefitsAndPerksRef} />
        <MeetTheTeam />
        <FrequentlyAskedQuestions ref={frequentlyAskedQuestionsRef} />
        <OpenRoles ref={openRolesRef} />
        <Footer />
      </Theme>
    </MediaContextProvider>
  );
}
